<template>
    
<div class="row mb-5 pb-5" v-if="this.search == 'all' || search == 'ingredient-functions'">
    <div class="col-12">

        <h2 class="section__title mb-5">{{title}}</h2>

        <ul class="nav nav--ingredient" id="ingredient-list">

            <li class="nav-item" v-for="(item, index) in computedItems" :key="index">
                <a class="nav-link" :href="item.url" :target="item.target">
                    <div v-html="$textHighlight(item.title, this.keyword)"></div>
                </a>
            </li>

        </ul>

        <p v-if="items.length == 0">
            <span v-if="keyword">"<b>{{ keyword }}</b>" -</span> {{textnoresult}}
        </p>
        
    </div>
</div>

</template>


<script>

let axios = require('axios')

export default {
    props: [
        'items',
        'title',
        'search',
        'keyword',
        'textreadmore',
        'textviewmore',
        'textnoresult',
        'token',
        'lang',
    ],

    data() {
        return {
            limit : 8,
        }
    },

    computed:{
        computedItems(){
            return (this.search == 'all' && !this.keyword ) ? this.items.slice(0,this.limit) : this.items;
        },
    },

    watch: {
        keyword() {
            this.getIngredientFunctions();
        },
        search() { 
            this.getIngredientFunctions();
        },
    },

    methods: {

        getIngredientFunctions() {

            if(this.search == 'ingredient-functions') {
                var vm = this;
                vm.$emit('setLoading', 'preloader-search--reload');

                let $endpoint = `/api/${vm.lang}/search/ingredient-functions?token=${vm.token}&keyword=${vm.keyword}`;
                axios.get($endpoint).then(function (response) {

                    vm.$emit('updateItems', 'ingredientFunctions', response.data.data);

                })
                .catch(function (error) {
                    console.error(error);
                })
                .then(function () {

                    vm.$emit('setLoading', '');
                })
            }

        },

    },

    mounted() {
        
    },

}

</script>